/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_hint_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid Roman numeral (1–3999).`)
};

const es_rn_hint_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa un numeral romano válido (1–3999).`)
};

const de_rn_hint_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine gültige römische Zahl ein (1–3999).`)
};

const nl_rn_hint_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een geldig Romeins getal in (1–3999).`)
};

const fr_rn_hint_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un chiffre romain valide (1–3999).`)
};

const it_rn_hint_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un numerale romano valido (1–3999).`)
};

const pt_br2_rn_hint_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um numeral romano válido (1–3999).`)
};

const pt_rn_hint_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um numeral romano válido (1–3999).`)
};

const ja_rn_hint_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効なローマ数字を入力してください(1〜3999)。`)
};

const zh_rn_hint_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入有效的罗马数字（1–3999）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_hint_roman = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_hint_roman(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_hint_roman", locale)
	if (locale === "en") return en_rn_hint_roman(inputs)
	if (locale === "es") return es_rn_hint_roman(inputs)
	if (locale === "de") return de_rn_hint_roman(inputs)
	if (locale === "nl") return nl_rn_hint_roman(inputs)
	if (locale === "fr") return fr_rn_hint_roman(inputs)
	if (locale === "it") return it_rn_hint_roman(inputs)
	if (locale === "pt-BR") return pt_br2_rn_hint_roman(inputs)
	if (locale === "pt") return pt_rn_hint_roman(inputs)
	if (locale === "ja") return ja_rn_hint_roman(inputs)
	return zh_rn_hint_roman(inputs)
};